<header class="notification-header">
  @if (value?.title) {
    <h2>{{ value.title }}</h2>
  }
  <app-icon name="cross" width="16px" height="16px" (click)="close()" />
</header>

@if (value?.message) {
  <div class="notification-content">
    <app-icon name="warning" width="30px" height="30px" />
    <p>{{ value.message }}</p>
  </div>
}
